import { render, staticRenderFns } from "./businessTemplateView.vue?vue&type=template&id=295f4732&scoped=true&"
import script from "./businessTemplateView.vue?vue&type=script&lang=js&"
export * from "./businessTemplateView.vue?vue&type=script&lang=js&"
import style0 from "./businessTemplateView.vue?vue&type=style&index=0&id=295f4732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295f4732",
  null
  
)

export default component.exports